import { BrowserRouter, Route, Routes } from "react-router-dom";
import UserVocWritePage from "./components/pages/UserVocWritePage";

import "./assets/css/style.css";
import AdminVocBoardPage from "./components/pages/AdminVocBoardPage";
import AdminVocDetailPage from "./components/pages/AdminVocDetailPage";
import UserVocDetailPage from "./components/pages/UserVocDetailPage";
import AdminVocLoginPage from "./components/pages/AdminVocLoginPage";
import styled from "styled-components";
import { RecoilRoot } from "recoil";

const AppWrapper = styled.div`
  display: flex;
  justify-content: center;
  min-height: 1000px;
`;

function App() {
  return (
    <RecoilRoot>
      <AppWrapper>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<UserVocWritePage />} />
            <Route path="/UserVocDetail" element={<UserVocDetailPage />} />
            <Route path="/UserVocWrite" element={<UserVocWritePage />} />
            <Route path="/AdminVocDetail" element={<AdminVocDetailPage />} />
            <Route path="/AdminVocBoard" element={<AdminVocBoardPage />} />
            <Route path="/AdminVocLogin" element={<AdminVocLoginPage />} />
          </Routes>
        </BrowserRouter>
      </AppWrapper>
    </RecoilRoot>
  );
}

export default App;
